<script lang="ts">
	import Icon from "@components/common/Icon.svelte";
	import type { ComponentProps } from "svelte";
	import searchIcon from "@core/assets/icons/search.svg?raw";
	import Input from "./Input.svelte";
	import Labelled from "./Labelled.svelte";

	let {
		value = $bindable(""),
		/* eslint-disable prefer-const */
		iconClass,
		...rest
		/* eslint-enable prefer-const */
	}: Omit<ComponentProps<typeof Input>, "type"> = $props();
</script>

<Labelled wrapperClass="contents" label={{ class: "grid [grid-template-areas:'stack']" }}>
	<Input {...rest} bind:value class={["!pr-[2.5rem] [grid-area:stack] z-30", rest.class]} />
	<div class="flex items-center justify-end [grid-area:stack] pr-1 md:pr-2">
		<Icon icon={searchIcon} class={["size-4 md:size-8 text-cmcmidgray z-40", iconClass]} />
	</div>
	{#snippet content()}{/snippet}
</Labelled>
